export default __webpack_public_path__ + "static/media/activities0.15bc142f.PNG";